/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Session_Minutes_QuestionInputs */

const en_us2_onboarding_session_minutes_question = /** @type {(inputs: Onboarding_Session_Minutes_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How long can each session take?`)
};

const pt_br2_onboarding_session_minutes_question = /** @type {(inputs: Onboarding_Session_Minutes_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto tempo cada treino pode durar?`)
};

const es_419_onboarding_session_minutes_question = /** @type {(inputs: Onboarding_Session_Minutes_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuánto puede durar cada entrenamiento?`)
};

const pt_pt2_onboarding_session_minutes_question = /** @type {(inputs: Onboarding_Session_Minutes_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto tempo pode durar cada treino?`)
};

const fr_fr2_onboarding_session_minutes_question = /** @type {(inputs: Onboarding_Session_Minutes_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combien de temps peut durer chaque séance ?`)
};

const de_de2_onboarding_session_minutes_question = /** @type {(inputs: Onboarding_Session_Minutes_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie lange darf eine Einheit dauern?`)
};

const it_it2_onboarding_session_minutes_question = /** @type {(inputs: Onboarding_Session_Minutes_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto può durare ogni sessione?`)
};

/**
* | output |
* | --- |
* | "How long can each session take?" |
*
* @param {Onboarding_Session_Minutes_QuestionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_session_minutes_question = /** @type {((inputs?: Onboarding_Session_Minutes_QuestionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Session_Minutes_QuestionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_session_minutes_question(inputs)
	if (locale === "es-419") return es_419_onboarding_session_minutes_question(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_session_minutes_question(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_session_minutes_question(inputs)
	if (locale === "de-DE") return de_de2_onboarding_session_minutes_question(inputs)
	if (locale === "it-IT") return it_it2_onboarding_session_minutes_question(inputs)
	return en_us2_onboarding_session_minutes_question(inputs)
});
export { onboarding_session_minutes_question as "onboarding.session_minutes.question" }